<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.galeri.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="galeriForm" :rules="rulesGalerilar" ref="galeriForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-collapse v-model="activeCollapse">
                        <el-collapse-item title="Resim Ayarları" name="7">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.galeri.tanimlama.resim")'
                                                  prop="resim">:
                                        <el-upload
                                                class="resimler"
                                                action=""
                                                list-type="picture-card"
                                                multiple
                                                :file-list="imageListMain"
                                                :auto-upload="false"
                                                accept=".jpg,.jpeg,.png"
                                                :on-change="imageUpload"
                                                :on-preview="firstImage"
                                                :on-remove="imageRemove">
                                            <i slot="default" class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.galeri.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        size="mini" v-on:click="galeriTanimlama('galeriForm')"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="galeriForm.durum === '1'">{{$t('src.views.apps.galeri.tanimlama.galeriEkle')}}</label>
                                    <label v-else>Taslak Olarak Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('galeriForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          :title='$t("src.views.apps.haberler.tanimlama.kategori")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="kategori">
                                        <el-select
                                                :disabled="disabled"
                                                v-model="galeriForm.kategori"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.kategoriPlace")'
                                                style="width: 100%"
                                                v-on:change="kategoriChange">
                                            <el-option v-for="item in kategoriListe"
                                                       :key="item.gkategoriId"
                                                       :label="item.baslik"
                                                       :value="item.gkategoriId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <div style="font-style: italic">
                                        Galeri için kategori belirleyiniz.
                                    </div>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>


<script>
    import JQuery from 'jquery';

    let $ = JQuery;
    import galeriService from '../../../WSProvider/GaleriService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import haberKategoriService from "../../../WSProvider/HaberKategoriService";

    let base64 = require('base64_js');
    let userDataYilmazlar = "";
    export default {
        name: "GaleriTanimla",
        data() {
            return {
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                dialogImgServerVisible: false,
                // Form
                visibleSil: false,
                visibleWebSite: false,
                imageListMain: [],
                kategoriListe: [],
                kategoriId: '',
                disabled: false,
                galeriForm: {
                    resim: [],
                    kategori: '',
                    durum: "1",
                },
                rulesGalerilar: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                    link: [{
                        required: true,
                        message: "Lütfen Link Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted() {
            this.getKategoriListe();
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        methods: {
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },

            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('galeri', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                        var imgname = "galeri-" + functions.randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                    } else {
                        imgname = "galeri-" + functions.randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }

                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            getKategoriListe() {
                galeriService.kategoriList(1).then(response => {
                    if (response.status === 200) {
                        if (response.data.length === 0) {
                            notification.Status('warning', this, 'Kategori listesi boş! Lütfen önce kategori tanımlayınız.');
                            this.disabled = true;
                        } else {
                            this.kategoriListe = response.data;
                        }
                        if (response.data.length > 0) {
                            this.galeriForm.kategori = response.data[0].gkategoriId;
                            this.kategoriId = response.data[0].gkategoriId;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            kategoriChange(val) {
                if (val === '4') {
                    this.visibleWebSite = true;
                } else {
                    this.visibleWebSite = false;
                }
            },
            galeriTanimlama(formName) {
                let self = this;
                this.galeriForm.resim = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.galeriForm.resim.push(e.name);
                        });
                        galeriService.galeriYukle(this.galeriForm.resim,this.galeriForm.kategori).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Galeri başarıyla eklendi.');
                                this.resetForm(formName);
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir galeri zaten mevcut');

                            } else {
                                notification.Status(response.status, this);
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.imageListMain = [];
                this.visibleSil = false;
                this.galeriForm.kategori = this.kategoriId;
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

</script>

<style scoped>
    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>